import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-400b6be7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Evidence")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Evidence for the selected association, ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Loading evidence")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Error loading evidence")

import { watch, onMounted, ref } from "vue";
import AppTabs from "@/components/AppTabs.vue";
import AppDetails from "@/components/AppDetails.vue";
import AppDetail from "@/components/AppDetail.vue";
import AppTable from "@/components/AppTable.vue";
import AppNodeBadge from "@/components/AppNodeBadge.vue";
import AppRelationBadge from "@/components/AppRelationBadge.vue";
import { Node } from "@/api/node-lookup";
import { scrollToElement } from "@/router";
import { getAssociationEvidence } from "@/api/association-evidence";
import { breakUrl } from "@/util/string";
import { appendToBody } from "@/global/tooltip";
import { waitFor } from "@/util/dom";
import { Association } from "@/api/node-associations";
import { useQuery } from "@/util/composables";
import { snackbar } from "@/components/TheSnackbar";
import { downloadJson } from "@/util/download";
import { Cols } from "@/components/AppTable";

interface Props {
  /** current node */
  node: Node;
  /** selected association id */
  selectedAssociation: Association;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EvidenceViewer',
  props: {
    node: null,
    selectedAssociation: null
  },
  setup(__props: any) {

const props = __props as {
  /** current node */
  node: Node;
  /** selected association id */
  selectedAssociation: Association;
}



/** mode tabs */
const tabs = [
  {
    id: "summary",
    text: "Summary",
    icon: "clipboard",
    tooltip: "High-level overview of evidence",
  },
  {
    id: "table",
    text: "Table",
    icon: "table",
    tooltip: "All evidence data, in tabular form",
  },
];
const tab = ref(tabs[0].id);

/** table columns */
const cols: Cols = [
  {
    id: "subject",
    key: "subject",
    heading: "Subject",
    width: "max-content",
  },
  {
    id: "relation",
    key: "relation",
    heading: "Relation",
    width: "max-content",
  },
  {
    id: "object",
    key: "object",
    heading: "Object",
    width: "max-content",
  },
  {
    id: "codes",
    key: "codes",
    heading: "Evidence Codes",
    width: "max-content",
  },
  {
    id: "publications",
    key: "publications",
    heading: "Publications",
    width: "max-content",
  },
  {
    id: "sources",
    key: "sources",
    heading: "Sources",
  },
  {
    id: "references",
    key: "references",
    heading: "References",
  },
];

/** get evidence data */
const {
  query: getEvidence,
  data: evidence,
  isLoading,
  isError,
} = useQuery(
  async function () {
    /** scroll to evidence section */
    waitFor("#evidence", scrollToElement);

    /** get evidence data */
    const response = await getAssociationEvidence(
      props.selectedAssociation?.id
    );

    return response;
  },

  /** default value */
  { summary: { codes: [], publications: [], sources: [] }, table: [] }
);

/** download table data */
async function download() {
  /** warn user */
  snackbar(
    `Downloading data for ${evidence.value.table.length} table entries.`
  );

  downloadJson(evidence.value.table);
}

onMounted(getEvidence);
watch(() => props.selectedAssociation, getEvidence);

return (_ctx: any,_cache: any) => {
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppStatus = _resolveComponent("AppStatus")!
  const _component_AppLink = _resolveComponent("AppLink")!
  const _component_AppFlex = _resolveComponent("AppFlex")!
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_AppSection = _resolveComponent("AppSection")!

  return (_openBlock(), _createBlock(_component_AppSection, null, {
    default: _withCtx(() => [
      _createVNode(_component_AppHeading, { icon: "flask" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _hoisted_2,
        _hoisted_3,
        _createVNode(AppNodeBadge, { node: __props.node }, null, 8, ["node"]),
        _hoisted_4,
        _createVNode(AppRelationBadge, {
          relation: __props.selectedAssociation.relation
        }, null, 8, ["relation"]),
        _hoisted_5,
        _createVNode(AppNodeBadge, {
          node: __props.selectedAssociation.object
        }, null, 8, ["node"])
      ]),
      (_unref(isLoading))
        ? (_openBlock(), _createBlock(_component_AppStatus, {
            key: 0,
            code: "loading"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }))
        : (_unref(isError))
          ? (_openBlock(), _createBlock(_component_AppStatus, {
              key: 1,
              code: "error"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(AppTabs, {
              key: 2,
              modelValue: tab.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
              tabs: tabs,
              name: "Evidence viewing mode",
              url: false
            }, null, 8, ["modelValue"])),
      (tab.value === 'summary' && _unref(evidence).summary)
        ? (_openBlock(), _createBlock(AppDetails, { key: 3 }, {
            default: _withCtx(() => [
              _createVNode(AppDetail, {
                title: `Evidence Codes`,
                count: _unref(evidence).summary?.codes.length,
                icon: "flask"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evidence).summary?.codes, (code, index) => {
                    return (_openBlock(), _createBlock(_component_AppLink, {
                      key: index,
                      to: code.link
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(code.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["count"]),
              _createVNode(AppDetail, {
                title: `Sources`,
                count: _unref(evidence).summary?.sources.length,
                icon: "database"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evidence).summary?.sources, (source, index) => {
                    return (_openBlock(), _createBlock(_component_AppLink, {
                      key: index,
                      to: source,
                      innerHTML: _unref(breakUrl)(source)
                    }, null, 8, ["to", "innerHTML"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["count"]),
              _createVNode(AppDetail, {
                title: `Publications`,
                count: _unref(evidence).summary?.publications.length,
                icon: "book"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppFlex, {
                    gap: "small",
                    "h-align": "left"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evidence).summary?.publications, (publication, index) => {
                        return (_openBlock(), _createBlock(_component_AppLink, {
                          key: index,
                          to: publication.link
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(publication.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["count"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (tab.value === 'table' && _unref(evidence).table?.length)
        ? (_openBlock(), _createBlock(AppTable, {
            key: 4,
            cols: cols,
            rows: _unref(evidence).table || [],
            start: 0,
            total: _unref(evidence).table?.length || 0,
            "show-controls": false,
            onDownload: download
          }, {
            subject: _withCtx(({ cell }) => [
              _createVNode(AppNodeBadge, { node: cell }, null, 8, ["node"])
            ]),
            relation: _withCtx(({ cell }) => [
              _createVNode(AppRelationBadge, { relation: cell }, null, 8, ["relation"])
            ]),
            object: _withCtx(({ cell }) => [
              _createVNode(AppNodeBadge, { node: cell }, null, 8, ["node"])
            ]),
            codes: _withCtx(({ cell }) => [
              _createVNode(_component_AppFlex, {
                direction: "col",
                gap: "small",
                "h-align": "left"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cell, (code, index) => {
                    return (_openBlock(), _createBlock(_component_AppLink, {
                      key: index,
                      to: code.link,
                      "no-icon": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(code.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]),
            publications: _withCtx(({ cell }) => [
              _createVNode(_component_AppFlex, {
                direction: "col",
                gap: "small",
                "h-align": "left"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cell.slice(0, 1), (publication, index) => {
                    return (_openBlock(), _createBlock(_component_AppLink, {
                      key: index,
                      to: publication.link,
                      "no-icon": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(publication.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128)),
                  (cell.length > 1)
                    ? (_openBlock(), _createBlock(_component_tooltip, {
                        key: 0,
                        interactive: true,
                        "append-to": _unref(appendToBody)
                      }, {
                        content: _withCtx(() => [
                          _createVNode(_component_AppFlex, {
                            "h-align": "left",
                            gap: "tiny"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cell.slice(1), (publication, index) => {
                                return (_openBlock(), _createBlock(_component_AppLink, {
                                  key: index,
                                  to: publication.link
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(publication.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", null, "and " + _toDisplayString(cell.length - 1) + " more...", 1)
                        ]),
                        _: 2
                      }, 1032, ["append-to"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]),
            sources: _withCtx(({ cell }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cell, (code, index) => {
                return (_openBlock(), _createBlock(_component_AppLink, {
                  key: index,
                  to: code.link,
                  "no-icon": true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(code.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ]),
            references: _withCtx(({ cell }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cell, (code, index) => {
                return (_openBlock(), _createBlock(_component_AppLink, {
                  key: index,
                  to: code.link,
                  "no-icon": true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(code.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["rows", "total"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})